module.exports = __webpack_public_path__ + "img/consolidado-praca-faixa.515083e2.png";